import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const DURATION_PER_CLIENT_FILTER_SCHEMA = Object.freeze({
  ID: '',
  NAME: '',
  DURATION: 0,
});
const RECORD = generateSchema(DURATION_PER_CLIENT_FILTER_SCHEMA);
const KEYS: any = generateKeys(DURATION_PER_CLIENT_FILTER_SCHEMA);

export class DurationPerClientFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get duration(): number {
    return this.get(KEYS.DURATION);
  }
}
